/**
 * @flow
 * @relayHash 6d32273ff2b2f6c83abb9ba7d3a6d208
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type cityPage_city$ref = any;
export type srcCityQueryVariables = {|
  slug: string
|};
export type srcCityQueryResponse = {|
  +city: ?{|
    +$fragmentRefs: cityPage_city$ref
  |}
|};
export type srcCityQuery = {|
  variables: srcCityQueryVariables,
  response: srcCityQueryResponse,
|};
*/


/*
query srcCityQuery(
  $slug: String!
) {
  city(slug: $slug) {
    ...cityPage_city
  }
}

fragment cityPage_city on City {
  slug
  name
  caption
  color
  picture
  headerPicture
  seo {
    title
    description
  }
  social {
    twitter {
      type
      title
      image
      handle
      description
    }
    generic {
      title
      image
      description
    }
  }
  articles(first: 1000) {
    slug
    title
    readingTime
    picture
    caption
    city {
      slug
      color
      name
    }
    author {
      firstname
      lastname
    }
    publishedAt
  }
  products {
    slug
    name
    summary
    picture
    preview
  }
  events {
    slug
  }
  map {
    defaultCenter {
      latitude
      longitude
    }
    placeCategories {
      name
      markerIcon
      places {
        name
        picture
        placeId
        location {
          latitude
          longitude
        }
      }
    }
  }
  related {
    slug
    name
    caption
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "slug",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "color",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v10 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "latitude",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "longitude",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcCityQuery",
  "id": null,
  "text": "query srcCityQuery(\n  $slug: String!\n) {\n  city(slug: $slug) {\n    ...cityPage_city\n  }\n}\n\nfragment cityPage_city on City {\n  slug\n  name\n  caption\n  color\n  picture\n  headerPicture\n  seo {\n    title\n    description\n  }\n  social {\n    twitter {\n      type\n      title\n      image\n      handle\n      description\n    }\n    generic {\n      title\n      image\n      description\n    }\n  }\n  articles(first: 1000) {\n    slug\n    title\n    readingTime\n    picture\n    caption\n    city {\n      slug\n      color\n      name\n    }\n    author {\n      firstname\n      lastname\n    }\n    publishedAt\n  }\n  products {\n    slug\n    name\n    summary\n    picture\n    preview\n  }\n  events {\n    slug\n  }\n  map {\n    defaultCenter {\n      latitude\n      longitude\n    }\n    placeCategories {\n      name\n      markerIcon\n      places {\n        name\n        picture\n        placeId\n        location {\n          latitude\n          longitude\n        }\n      }\n    }\n  }\n  related {\n    slug\n    name\n    caption\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcCityQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "city",
        "storageKey": null,
        "args": v1,
        "concreteType": "City",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "cityPage_city",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcCityQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "city",
        "storageKey": null,
        "args": v1,
        "concreteType": "City",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          v5,
          v6,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "headerPicture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seo",
            "storageKey": null,
            "args": null,
            "concreteType": "SEO",
            "plural": false,
            "selections": [
              v7,
              v8
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "social",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialMedia",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "twitter",
                "storageKey": null,
                "args": null,
                "concreteType": "TwtrSlices",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  v7,
                  v9,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handle",
                    "args": null,
                    "storageKey": null
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "generic",
                "storageKey": null,
                "args": null,
                "concreteType": "GenSocialSlices",
                "plural": true,
                "selections": [
                  v7,
                  v9,
                  v8
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "articles",
            "storageKey": "articles(first:1000)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000,
                "type": "Int"
              }
            ],
            "concreteType": "Article",
            "plural": true,
            "selections": [
              v2,
              v7,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "readingTime",
                "args": null,
                "storageKey": null
              },
              v6,
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "City",
                "plural": false,
                "selections": [
                  v2,
                  v5,
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "Author",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstname",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastname",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "publishedAt",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "products",
            "storageKey": null,
            "args": null,
            "concreteType": "Product",
            "plural": true,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "summary",
                "args": null,
                "storageKey": null
              },
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "preview",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "events",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": true,
            "selections": [
              v2
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "map",
            "storageKey": null,
            "args": null,
            "concreteType": "CityMap",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "defaultCenter",
                "storageKey": null,
                "args": null,
                "concreteType": "GeoPoint",
                "plural": false,
                "selections": v10
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "placeCategories",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaceCategory",
                "plural": true,
                "selections": [
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "markerIcon",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "places",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Place",
                    "plural": true,
                    "selections": [
                      v3,
                      v6,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "placeId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "location",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "GeoPoint",
                        "plural": false,
                        "selections": v10
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "related",
            "storageKey": null,
            "args": null,
            "concreteType": "City",
            "plural": true,
            "selections": [
              v2,
              v3,
              v4
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '35b2faf8d34129b8fb48aeca0b84aa9c';
module.exports = node;
